import React from 'react';
import { FormattedMessage } from 'react-intl';
import { EasyClaimDataPrivacyLink } from 'src/easyclaim.api.client.typescript/src';
import styled from 'styled-components';

import { Markdown } from '../common/Markdown';
import { Modal } from '../common/Modal';

interface DataPrivacyModalProps {
	isOpen: boolean;
	onClose: () => void;
	onDataProtectionAccepted: () => void;
	dataPrivacyText?: string;
	dataPrivacyLinks?: EasyClaimDataPrivacyLink[] | null;
	getFileUrl: (fileId: number) => string;
}

export class DataPrivacyModal extends React.Component<DataPrivacyModalProps, {}> {
	modal?: Modal | null;
	render() {
		return (
			<Modal
				isOpen={this.props.isOpen}
				closeOnBackdropClick={true}
				onClose={this.props.onClose}
				header={
					<h2>
						<FormattedMessage id="dataPrivacyModal.headline" />
					</h2>
				}
				footer={
					<button className="accept-data-protection" onClick={this.props.onDataProtectionAccepted}>
						<FormattedMessage id="button.accept" />
					</button>
				}
				ref={(r) => (this.modal = r)}
			>
				<>
					{this.props.dataPrivacyLinks &&
						this.props.getFileUrl &&
						this.props.dataPrivacyLinks.map((l) => (
							<Link
								href={this.props.getFileUrl(l.id!)}
								target="_blank"
								onClick={(e: React.MouseEvent<HTMLAnchorElement>) => e.stopPropagation()}
								color={'#000'}
							>
								<Message>{l.name}</Message>
							</Link>
						))}
					<>
						<Markdown markdown={this.props.dataPrivacyText} escapeHtml={false} />
					</>
				</>
			</Modal>
		);
	}
}

const Link = styled.a`
	text-decoration: underline;
	cursor: pointer;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	:any-link,
	:visited,
	:link {
		color: ${(p) => p.color};
	}
`;

const Message = styled.div`
	text-align: center;
	margin-bottom: 1rem;
`;
